import React, { useState } from 'react';
import './Services.css';

const Services = () => {
  const [expandedService, setExpandedService] = useState(null);
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [showPricingModal, setShowPricingModal] = useState(null);

  const handleGetStarted = () => {
    window.open('https://forms.gle/NwYZnJaLvwkYBQDM6', '_blank');
  };

  const handleEnquireNow = () => {
    const whatsappNumber = '919599513613';
    const message = 'Hi, I would like to know more about your services.';
    const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappLink, '_blank');
  };

  const pricingData = {
    1: { // Company Registration
      title: "Company Registration",
      packages: [
        {
          name: "Starter",
          oldPrice: "₹999",
          newPrice: "₹999",
          description: "Best for startup who just started the company registration, no entities",
          features: [
            "Company Name Approval",
            "MOA and AOA",
            "Incorporation Certificate",
            "PAN + TAN",
            "ESI & PF Registration",
            "Real-time Services, DTH/IR Tracking",
            "Automated Post-Incorporation Compliance Reminders",
            "Built-in Invoicing Modules (Codex & Purchasers)"
          ]
        },
        {
          name: "Standard",
          oldPrice: "₹1,999",
          newPrice: "₹1,499",
          description: "Best for more founders – Organized, done-for-you setup",
          badge: "MOST POPULAR | 50% OFF",
          features: [
            "Company Name Approval",
            "MOA and AOA",
            "Incorporation Certificate",
            "PAN + TAN",
            "ESI & PF Registration",
            "Dedicated Filing Expert",
            "Compliances, Manner Kit",
            "Faster Priority Support",
            "Accurate Document Naming",
            "Real-time Service Status Tracking",
            "Automated Post-Incorporation Compliance Reminders",
            "Built-in Invoicing Modules (Codex & Purchasers)"
          ]
        },
        {
          name: "Pro",
          oldPrice: "₹3,499",
          newPrice: "₹3,499",
          description: "Best for founders who want the best and perks formed from day one",
          features: [
            "Company Name Approval",
            "MOA and AOA",
            "Incorporation Certificate",
            "PAN + TAN",
            "ESI & PF Registration",
            "Inquiry Filing",
            "Free Trademark Registration",
            "Free MSME Registration",
            "Governance Compliant Setup",
            "Business Ready Setup",
            "Dedicated Filing Expert",
            "Compliance Starter Kit",
            "Quarterly Compliance Support"
          ]
        }
      ]
    }
  };

  const services = [
    {
      id: 1,
      title: "Company Registration",
      icon: "📋",
      subservices: [
        "Private Limited Company",
        "Limited Liability Partnership",
        "One Person Company",
        "Sole Proprietorship",
        "Nidhi Company",
        "Producer Company",
        "Partnership Firm",
        "Startup India Registration",
        "Business Registration"
      ]
    },
    {
      id: 2,
      title: "IP & Trademark",
      icon: "🛡️",
      subservices: [
        "Trademark Registration",
        "Copyright Registration",
        "Patent Registration",
        "Infringement Protection",
        "Design Registration"
      ],
      expandable: true,
      nested: {
        "Trademark Registration": [
          "Trademark Search",
          "Respond to TM Objection",
          "Well Known Trademark",
          "Trademark Watch",
          "Trademark Renewal",
          "Trademark Assignment",
          "USA Trademark",
          "Trademark Class Finder",
          "International Trademark"
        ],
        "Copyright Registration": [
          "Copyright Music",
          "Copyright Literary Works",
          "Copyright Photography",
          "Copyright Software",
          "Copyright Design",
          "Copyright Assignment",
          "Copyright Renewal",
          "Copyright Infringement",
          "Copyright Protection"
        ],
        "Patent Registration": [
          "Indian Patent Search",
          "Provisional Patent Application",
          "Patent Amendment",
          "Patent Renewal",
          "Patent Assignment",
          "Patent Opposition",
          "International Patent",
          "Patent Infringement",
          "Patent Protection"
        ],
        "Infringement Protection": [
          "Copyright Infringement",
          "Patent Infringement",
          "Trademark Infringement",
          "Design Infringement",
          "Cease and Desist Notice",
          "Infringement Litigation",
          "Infringement Mediation",
          "Damages Assessment",
          "IP Violation Report"
        ],
        "Design Registration": [
          "Logo Design",
          "Industrial Design",
          "Graphic Design",
          "Design Search",
          "Design Renewal",
          "Design Assignment",
          "Design Modification",
          "Design Protection",
          "Design Infringement"
        ]
      }
    },
    {
      id: 3,
      title: "Head Business contracts and real estate",
      icon: "✅",
      subservices: [
        "Non Disclosure Agreement NDA",
        "Service Level Agreement",
        "Franchise Agreement",
        "Master Service Agreement",
        "Share Holder's Agreement",
        "Joint Venture Agreement",
        "Founder's Agreement",
        "Vendor Agreement",
        "Consultancy Agreement",
        "Memorum of Understanding",
        "Succession Certificate",
        "Scope of Work Agreement",
        "Share Purchase Agreement",
        "Relinquishment Deed",
        "Legal Heir Certificate",
        "Trade License",
        "Noncompete Agreement",
        "Finance Agreement",
        "GDPR",
        "Rental Agreement",
        "Sale Deed",
        "Gift Deed",
        "Rental Tenant Notice"
      ]
    }
  ];

  return (
    <section className="services" id="services">
      <div className="services-container">
        <div className="services-header">
          <p className="services-label">OUR SERVICES</p>
          <h2 className="services-title">We Handle The Legal</h2>
          <p className="services-subtitle">Comprehensive business solutions tailored to your needs</p>
        </div>

        {/* Services Grid */}
        <div className="services-grid">
          {services.map((service) => (
            <div key={service.id} className="service-card">
              <div 
                className="service-card-header"
                onClick={() => setExpandedService(expandedService === service.id ? null : service.id)}
              >
                <div className="service-icon">{service.icon}</div>
                <h3 className="service-title-main">{service.title}</h3>
                <div className={`expand-arrow ${expandedService === service.id ? 'open' : ''}`}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M7 8L10 11L13 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>

              {expandedService === service.id && !service.expandable && (
                <div className="service-subservices">
                  <ul>
                    {service.subservices.map((sub, idx) => (
                      <li key={idx} className="subservice-item" onClick={service.id === 3 ? handleGetStarted : () => setShowPricingModal(service.id)}>
                        <span className="sub-dot">•</span>
                        {sub}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {expandedService === service.id && service.expandable && (
                <div className="service-nested-container">
                  <div className="nested-categories">
                    {service.subservices.map((category, idx) => (
                      <div key={idx}>
                        <div 
                          className={`nested-category ${expandedCategory === category ? 'active' : ''}`}
                          onClick={() => setExpandedCategory(expandedCategory === category ? null : category)}
                        >
                          <span className="category-name">{category}</span>
                          <span className="category-arrow">→</span>
                        </div>

                        {expandedCategory === category && (
                          <ul className="nested-subservices">
                            {service.nested[category].map((subitem, subidx) => (
                              <li key={subidx} className="nested-item" onClick={handleGetStarted}>
                                <span className="sub-dot">✓</span>
                                {subitem}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Enquire Now Button */}
        <div className="services-footer">
          <button className="enquire-button" onClick={handleEnquireNow}>
            Enquire Now
          </button>
        </div>
      </div>

      {/* Pricing Modal */}
      {showPricingModal && pricingData[showPricingModal] && (
        <div className="pricing-modal-overlay" onClick={() => setShowPricingModal(null)}>
          <div className="pricing-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowPricingModal(null)}>✕</button>
            
            <div className="pricing-header">
              <h2>Choose The Best {pricingData[showPricingModal].title} Package For Your Business</h2>
              <p>Guaranteed Application Submission within 7 Days — or Get a 100% Money Back Guarantee!</p>
            </div>

            <div className="pricing-cards-container">
              {pricingData[showPricingModal].packages.map((pkg, idx) => (
                <div key={idx} className={`pricing-card ${pkg.badge ? 'popular' : ''}`}>
                  {pkg.badge && <div className="popular-badge">{pkg.badge}</div>}
                  
                  <h3 className="plan-name">{pkg.name}</h3>
                  <p className="plan-description">{pkg.description}</p>
                  
                  <div className="plan-pricing">
                    <div className="price-container">
                      {pkg.oldPrice && <span className="old-price">{pkg.oldPrice}</span>}
                      <span className="new-price">{pkg.newPrice}</span>
                    </div>
                    <p className="price-note">+ GST (Can option available)</p>
                  </div>

                  <button className="get-started-btn" onClick={handleGetStarted}>
                    Get Started
                  </button>

                  <div className="plan-features">
                    <p className="features-title">What You'll Get</p>
                    <ul>
                      {pkg.features.map((feature, fidx) => (
                        <li key={fidx}>
                          <span className="feature-check">✓</span>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>

            <div className="pricing-footer">
              <p>Have questions? <a href="mailto:support@lexpitch.com">Contact our support team</a></p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Services;
